
// Mutations
export const BINDPROPREQSETS = 'BINDPROPREQSETS'
export const UNBINDPROPREQSETS = 'UNBINDPROPREQSETS'

export const RESETPROPREQSETS = 'RESETPROPREQSETS'

// Actions
export const ADDPROPREQSET = 'ADDPROPREQSET';
export const EDITPROPREQSET = 'EDITPROPREQSET';
export const DELETEPROPREQSET = 'DELETEPROPREQSET';


import db from '../../firebase/firebase'
import { addBound, bindArray, removeBound, updateBound } from '../helpers/binding';
import { generateUpdatesForObject } from '../helpers/updates'

export default {
  state: () => ({
    propreqsets: [],
  }),

  getters: {
    getPropReqSet: ( state ) => ( propreqsetkey ) => {
      return state.propreqsets.find( p => p['.key'] == propreqsetkey)
    },
  },

  mutations: {
    addBoundPropReqSet: ( state, { snapshot } ) => addBound( state.propreqsets, snapshot ),
    removeBoundPropReqSet: ( state, { snapshot } ) => removeBound( state.propreqsets, snapshot ),
    updateBoundPropReqSet: ( state, { snapshot } ) => updateBound( state.propreqsets, snapshot ),

    [RESETPROPREQSETS] ( state ) {
      state.propreqsets = []
    },
  },

  actions: {
    async [BINDPROPREQSETS] ( { commit }, guild ) {
      const ref = db.ref( 'guildPropReqSets/' +
                          guild['.key'] + '/propreqsets' )
      return bindArray( ref, commit, 'PropReqSet')
    },
    [UNBINDPROPREQSETS] ( { rootState } ) {
      let guild = rootState.guilds.selectedGuild
      if( guild ) {
        db.ref( 'guildPropReqSets/' + guild['.key'] + '/propreqsets' ).off()
      }
    },
    
    [ADDPROPREQSET] ( context, { guild, propreqset } ) {
      if( guild ) {
        return db.ref( 'guildPropReqSets/' + guild['.key'] + '/propreqsets' ).push( propreqset )
      }
    },
    [EDITPROPREQSET] ( context, { guild, propreqset, newvalues } ) {
      if( guild && propreqset ) {
        let updates = generateUpdatesForObject(
          'guildPropReqSets/' + guild['.key'] +
          '/propreqsets/' + propreqset['.key'] + '/', newvalues )
        return db.ref().update( updates )
      }
    },
    async [DELETEPROPREQSET] ( { rootState }, { guild, propreqset } ) {

      if( guild && propreqset ) {
        let updates = {}

        // First get all the lockouts from all guildDestinations
        let lockoutKeys = []

        for( let destination of rootState.destinations.destinations ) {
          let destLockoutsSnapshot = await db.ref( 'destinationLockouts/' +
                                                   destination['.key'] +
                                                   '/lockouts/' ).get()
          let destLockouts = destLockoutsSnapshot.val()

          for( let lockoutKey in destLockouts ) {
            lockoutKeys.push( lockoutKey )
          }
        }

        // For each of the lockouts, get the RaidEvents, check whether it uses this propreqset
        for( let lockoutKey of lockoutKeys ) {
          let raideventsSnapshot = await db.ref( 'lockouts/' + lockoutKey
                                                 + '/raidevents/' ).get()
          let raidevents = raideventsSnapshot.val()

          for( let raideventID in raidevents ) {
            let raidevent = raidevents[ raideventID ]

            if( raidevent.propreqsetkey == propreqset['.key'] ) {
              updates[ 'lockouts/' + lockoutKey + '/raidevents/'
                       + raideventID + '/propreqsetkey' ] = null
            }
          }
        }

        // Remove the propreqset itself
        updates[ 'guildPropReqSets/' + guild['.key' ]
                 + '/propreqsets/' + propreqset['.key'] ] = null

        return db.ref().update( updates )
      }
    },

  },
}
